import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

// Blocks re-entry to /authenticate once MFA is already complete - e.g. via a stale
// browser-history entry after pressing Back from the Home/Dashboard page - so the
// user is redirected away before AuthenticateComponent ever mounts, with no flash.
//
// Deliberately sync-only (sessionStorage flag, no profile API call): the scenario this
// fixes always has the flag set (completeVerification() sets it before navigating away),
// and calling userProfile() here would duplicate the request AuthenticateComponent's own
// ngOnInit already makes on first-time MFA landings, slowing that page down for no benefit.
@Injectable({ providedIn: 'root' })
export class MfaCompletedGuard implements CanActivate {

  constructor(private readonly router: Router) { }

  canActivate(): boolean {
    if (sessionStorage.getItem('cellVerificationDone') === 'true') {
      const returnUrl = sessionStorage.getItem('mfaReturnUrl') || '/portal/home';
      sessionStorage.removeItem('mfaReturnUrl');
      this.router.navigateByUrl(returnUrl, { replaceUrl: true });
      return false;
    }
    return true;
  }
}
